import { render } from "./BlankSpaceDivider.vue?vue&type=template&id=901d6000&scoped=true"
import script from "./BlankSpaceDivider.vue?vue&type=script&lang=js"
export * from "./BlankSpaceDivider.vue?vue&type=script&lang=js"

import "./BlankSpaceDivider.vue?vue&type=style&index=0&id=901d6000&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901d6000"]])

export default __exports__